import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const containerStyles: AbgSxProps = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: { xs: 'unset', md: '100px' },
  justifyContent: 'space-between',
  backgroundColor: '#F3EEEF',
  paddingRight: { xs: '16px', md: '24px' },
  gap: '16px',
};

export const imageStyles: AbgSxProps = {
  position: 'relative',
  width: { xs: '100px', md: '142px' },
  clipPath: {
    xs: 'ellipse(80% 100% at 20% 50%)',
    md: 'circle(142px at 0 50%)',
  },
  img: {
    minWidth: { xs: '100px', md: '142px' },
    objectFit: 'cover',
  },
  height: '100%',
};

export const contentWrapper: AbgSxProps = {
  display: 'grid',
  columnGap: '16px',
  alignItems: 'center',
  height: '100%',
  gridTemplateColumns: {
    xs: '100px auto',
    md: '142px auto',
  },
};

export const contentContainerStyles: AbgSxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: {
    xs: '8px 0 ',
    md: '0',
  },
};

export const subtitleStyles: AbgSxProps = {
  marginTop: '8px',
  '& > p': { margin: 0 },
};

export const buttonStyles: AbgSxProps = {
  '& > p': { margin: 0, color: paletteBase.black },
  color: paletteBase.black,
  textDecoration: 'none',
  display: 'flex',
  rigjht: '24px',
  gap: '8px',
  alignItems: 'center',
};

export const buttonTextStyles: AbgSxProps = {
  display: { xs: 'none', md: 'block' },
};

export const iconStyles: AbgSxProps = {
  width: { xs: '16px', sm: '16px', md: '24px' },
  height: { xs: '16px', sm: '16px', md: '24px' },
  color: paletteBase.black,
};
